import React, { useEffect, useState } from 'react';
import { ListChecks, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { ClientChecklist } from './ClientChecklist';
import { checklistsAPI } from '../lib/api';

const TABS = [
  { kind: 'rrss_onboarding', label: 'Onboarding RRSS', servicio: 'rrss' },
  { kind: 'rrss_mensual', label: 'Ciclo mensual RRSS', servicio: 'rrss' },
  { kind: 'ads', label: 'Onboarding Ads', servicio: 'ads' },
];
const SERVICIOS = [['rrss', 'Redes sociales'], ['ads', 'Ads']];

export const ClientChecklistsSection = ({ clientId }) => {
  const [servicios, setServicios] = useState(null);
  const [tab, setTab] = useState(null);

  useEffect(() => {
    setServicios(null);
    checklistsAPI.getServices(clientId).then((r) => setServicios(r.servicios)).catch((e) => toast.error(e.message));
  }, [clientId]);

  const visible = TABS.filter((t) => servicios?.includes(t.servicio));
  const current = visible.find((t) => t.kind === tab)?.kind || visible[0]?.kind;

  const toggle = (s) => {
    const next = servicios.includes(s) ? servicios.filter((x) => x !== s) : [...servicios, s];
    setServicios(next);
    checklistsAPI.setServices(clientId, next).catch((e) => toast.error(e.message));
  };

  return (
    <Card data-testid="client-checklists-section">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 flex-wrap gap-2">
        <CardTitle className="flex items-center gap-2"><ListChecks className="w-5 h-5 text-primary" />Checklists internos <span className="text-xs font-normal text-muted-foreground">· el cliente no los ve</span></CardTitle>
        {servicios && (
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">Servicios:
            {SERVICIOS.map(([v, l]) => (
              <button key={v} type="button" onClick={() => toggle(v)} data-testid={`checklist-service-${v}`}
                className={`px-3 h-7 rounded-full border text-xs transition-colors ${servicios.includes(v) ? 'bg-primary text-primary-foreground border-primary' : 'hover:bg-muted text-foreground'}`}>{l}</button>
            ))}
          </div>
        )}
      </CardHeader>
      <CardContent>
        {!servicios ? <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin" /></div>
          : !visible.length ? <p className="text-sm text-muted-foreground text-center py-8" data-testid="checklists-none">Marca qué servicios tiene contratados el cliente para ver sus checklists.</p> : (
            <Tabs value={current} onValueChange={setTab}>
              <TabsList className="mb-4">
                {visible.map((t) => <TabsTrigger key={t.kind} value={t.kind} data-testid={`checklist-tab-${t.kind}`}>{t.label}</TabsTrigger>)}
              </TabsList>
              {visible.map((t) => <TabsContent key={t.kind} value={t.kind}><ClientChecklist clientId={clientId} kind={t.kind} /></TabsContent>)}
            </Tabs>
          )}
      </CardContent>
    </Card>
  );
};
